<script setup>
  import { RouterLink, useRouter } from 'vue-router'

  import { computed } from 'vue'

  import { getActiveClubId } from './useActiveClub.js'

  const props = defineProps({
    to: {
      type: [String, Object],
      required: true,
    },
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: String,
    custom: Boolean,
    append: Boolean,
  })

  const router = useRouter()

  const computedTo = computed(() => {
    const activeClubId = getActiveClubId()

    let baseTo = props.to

    // Use router.resolve here
    const resolved = router.resolve(baseTo, undefined, props.append)

    // Then manipulate the query
    if (!activeClubId) {
      return resolved.href
    }
    const url = new URL(resolved.href, window.location.origin)
    url.searchParams.set('activeClubId', activeClubId)

    return url.pathname + url.search
  })

  const computedProps = computed(() => {
    /* oxlint-disable no-unused-vars */
    const { to, ...otherProps } = props
    return otherProps
  })
</script>

<template>
  <RouterLink v-bind="computedProps" :to="computedTo">
    <slot />
  </RouterLink>
</template>
